import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

import type { ErrorContextState } from './types'

type ErrorContextStore = ErrorContextState & {
	actions: {
		setContext: (partial: Partial<ErrorContextState>) => void
	}
}

const initialState: ErrorContextState = {
	feature: 'unknown',
}

const errorContextStore = createWithEqualityFn<ErrorContextStore>()(
	(set) => ({
		...initialState,

		actions: {
			setContext: (partial) =>
				set((state) => ({ ...state, ...partial }), false),
		},
	}),
	shallow,
)

/**
 * Read current error context outside React (e.g. from API client).
 * Returns feature, section, entityId, and metadata.
 */
export const getErrorContext = (): ErrorContextState => {
	const { actions: _, ...state } = errorContextStore.getState()
	return state
}

export const useErrorContextActions = () =>
	errorContextStore((state) => state.actions)

export { errorContextStore }
